angular.module('PTK.directives.Filters', [])

.filter('html', ['$sce', function ($sce) { 
    return function (text) {
        return $sce.trustAsHtml(text);
    };    
}])

.filter('igenNem', function() { 
	  var igennemHash = {
		0: 'Nem',
		1: 'Igen'
	  };
	  
	  return function(input) {
		  return igennemHash[input];
	  };
	})

.filter('truefalse', function() { 
	  var igennemHash = {
		0: 'false',
		1: 'true'
	  };
	  
	  return function(input) {
		  return igennemHash[input];
	  };
	})
	
.filter('video', ['Service', '$sce', function (Service, $sce) { 
	
	  return function(input) {
		  
		  		var regExp = /{video}([\s\S]*){\/video}/;
				var matches = regExp.exec(input);
				
				var ertek = "";
			
				if (matches && matches.length){

					var value = matches[1];
					if (Service.offline){
						value = value.replace(/^http:\/\/[^\/]*?\//g,"");
						ertek = value.replace(/ /g,"%20");
					}else{
						ertek = value.replace(/ /g,"%20");
					}
				}
		  
		  return $sce.trustAsResourceUrl( ertek );
	  };
	}])
	
	// PTK.filter('csakCimKiiras', function() {

		// return function (input, map) {
			// console.log (map);
		  // return map[input-1].name;
		// };
		
	
	// });
	
.filter('csakCimKiiras',function () {
    return function (input, map, idField, valueField, initial) {
	
		console.log ("--");
	
      if(typeof map !== "undefined") {
        for (var i = 0; i < map.length; i++) {
          if(map[i][idField] == input)
          {
            return map[i][valueField];
          }
        }
      } else if(initial) {
        return initial;
      }
      return input;
    };
  })

 .filter('csakszam', function() { 
	  
	  return function(input) {
	  
		  if ( Number(input) != input ){
				input = 0;
		  }
	  
		  return (input);
	  };
	})
	
.filter('csakpxvagyszaz', function() { 
	  
	  return function(input) {
	  
		  if ( input != "px" && input != "%" ){
				input = "px";
		  }
	  
		  return (input);
	  };
	})
	
.filter('szampxbol', function() { 
	  
	  return function(input) {
	  
			var pattern = /^[\s\S]*?([0-9]*)/i;
			var talalatok = pattern.exec(input);
	  
			if (talalatok!=null && talalatok.length){
				return (talalatok[1]);
			}else{
				return ("");
			}
	  };
	})
	
.filter('csakszin', function() { 
	  
	  return function(input) {
	  
			var pattern = /^#[0-9a-f]{3,6}$/i;
			var talalatok = pattern.exec(input);
	  
			if (talalatok!=null && talalatok.length){
				return (talalatok[0]);
			}else{
				return ("");
			}
	  };
	});
	

	